import React from 'react';
import { Navbar, Hero, TrustBar } from './components/Hero';
import { PersonalNote, Introduction, Chapters } from './components/Content';
import { FAQ, Pricing, Footer } from './components/Pricing';
export function App() {
  return <div className="min-h-screen bg-cream font-inter selection:bg-terracotta/20" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <PersonalNote data-id="element-5" />
        <Introduction data-id="element-6" />
        <Chapters data-id="element-7" />
        <FAQ data-id="element-8" />
        <Pricing data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}